// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"461":"awards","501":"apple","516":"team","619":"live-demo","818":"client","912":"contacts","946":"news"}[chunkId] + "." + {"461":"c7e5900e","501":"9b8f3490","516":"bed42a1a","619":"86b7a80b","818":"c7bcc8ea","912":"c4e53592","946":"ac615340"}[chunkId] + ".css";
};